document.addEventListener('DOMContentLoaded', function () {
    // Get the logo element
    var oldLogo = document.querySelector('.site-logo-image');
    oldLogo.style.display = 'none';

    // Define the default logo URL
    var defaultLogoUrl = '//cdn.shopify.com/s/files/1/0671/1774/4439/files/shopsta-full-blue-logo.png';

    // Define a map for the domains and their corresponding logos
    var domainLogoMap = {
        'shopsta.co': '//cdn.shopify.com/s/files/1/0671/1774/4439/files/shopsta-full-blue-logo.png',
        'shopsta.es': '//cdn.shopify.com/s/files/1/0671/1774/4439/files/shopsta-full-blue-logo.png',
        'shopsta.fr': '//cdn.shopify.com/s/files/1/0671/1774/4439/files/shopsta-full-blue-logo.png',
        'shopsta.at': '//cdn.shopify.com/s/files/1/0671/1774/4439/files/shopsta-full-blue-logo.png',
        'shopsta.be': '//cdn.shopify.com/s/files/1/0671/1774/4439/files/shopsta-full-blue-logo.png',
        'shopsta.ch': '//cdn.shopify.com/s/files/1/0671/1774/4439/files/shopsta-full-blue-logo.png',
        'shopsta.cz': '//cdn.shopify.com/s/files/1/0671/1774/4439/files/shopsta-full-blue-logo.png',
        'shopsta.dk': '//cdn.shopify.com/s/files/1/0671/1774/4439/files/shopsta-full-blue-logo.png',
        'shopsta.it': '//cdn.shopify.com/s/files/1/0671/1774/4439/files/shopsta-full-blue-logo.png',
        'shopsta.nl': '//cdn.shopify.com/s/files/1/0671/1774/4439/files/shopsta-full-blue-logo.png',  
        'shopsta.pl': '//cdn.shopify.com/s/files/1/0671/1774/4439/files/shopsta-full-blue-logo.png',   
        'shopsta.pt': '//cdn.shopify.com/s/files/1/0671/1774/4439/files/shopsta-full-blue-logo.png',   
        'shopsta.se': '//cdn.shopify.com/s/files/1/0671/1774/4439/files/shopsta-full-blue-logo.png',  
        'shopsta.hu': '//cdn.shopify.com/s/files/1/0671/1774/4439/files/shopsta-full-blue-logo.png',   
        'shopsta.ie': '//cdn.shopify.com/s/files/1/0671/1774/4439/files/shopsta-full-blue-logo.png'
    };

    // Get the current domain
    var domain = window.location.hostname;
    if (domain.startsWith('www.')) {
        domain = domain.substring(4);
    }

    var newLogoSrc;
    if (localStorage.getItem('logo')) {
        newLogoSrc = localStorage.getItem('logo');
    } else if (domainLogoMap.hasOwnProperty(domain)) {
        newLogoSrc = domainLogoMap[domain];
        localStorage.setItem('logo', newLogoSrc);
    } else {
        // Use the default logo if the domain is not in the domainLogoMap
        newLogoSrc = defaultLogoUrl;
    }

    if (newLogoSrc) {
        var newLogo = new Image();
        newLogo.src = newLogoSrc;
        newLogo.classList.add('site-logo-image');

        newLogo.onload = function() {
            oldLogo.parentNode.replaceChild(newLogo, oldLogo);
            newLogo.style.display = 'block';
        }
    }
});
